import { styled } from "@vitality-ds/system";
import BaseChipStyles from "./styles/BaseChip.styles";
import BaseChipLabelContainerStyles from "./styles/BaseChipLabelContainer.styles";
export var BaseChip = styled("div", BaseChipStyles);
export var BaseChipLabelContainer = styled("div", BaseChipLabelContainerStyles);